













import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ListMessages extends Vue {
  @Prop(Boolean)
  public loading: boolean;
  @Prop(Boolean)
  public error: boolean;
  @Prop()
  public errorMessage?: string;
  @Prop()
  public loadingMessage?: string;

  public messages: any = {
    errorMessage: 'Ocorreu um erro ao se comunicar com a API.',
    loadingMessage: 'Carregando itens...',
  };

  public beforeMount(): void {
    this.messages.errorMessage =
      this.errorMessage || this.messages.errorMessage;
    this.messages.loadingMessage =
      this.loadingMessage || this.messages.loadingMessage;
  }
}
